import { motion } from "framer-motion";
import { FLAVOURS } from "@/data/content";

export const BagPicker = ({ onPick, disabled }) => (
  <div data-testid="game-bag-picker" className="grid grid-cols-5 gap-2 sm:gap-4 items-end">
    {FLAVOURS.map((f, i) => (
      <motion.button key={f.key} type="button" disabled={disabled} data-testid={`game-bag-${f.key}`} onClick={() => onPick(f.key)}
        aria-label={`Pick the ${f.name} mystery bag`}
        animate={{ rotate: [0, -6, 6, -4, 4, 0], y: [0, -4, 0] }}
        transition={{ duration: 0.9, repeat: Infinity, repeatDelay: 1.2 + i * 0.25, delay: i * 0.18 }}
        whileHover={{ scale: 1.08, y: -8 }} whileTap={{ scale: 0.95 }}
        className="relative flex flex-col items-center gap-2 disabled:opacity-60">
        <img src={f.img} alt="" className="h-24 sm:h-36 w-auto object-contain drop-shadow-[0_14px_16px_rgba(27,21,48,0.25)]" />
        <span className="absolute top-1/3 grid place-items-center h-8 w-8 sm:h-10 sm:w-10 rounded-full bg-[#1B1530] text-white font-display text-lg sm:text-xl shadow-lg">?</span>
      </motion.button>
    ))}
  </div>
);
